import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DrawerErrorState = props => {
  const {
    onRetry
  } = props;
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "300",
    paddingInline: "300",
    backgroundColor: "fill-alert-subtle",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "start",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-alert-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.drawer.error.loadFailed"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        size: "extra-small",
        onClick: onRetry,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.drawer.error.retry"
        })
      })]
    })
  });
};